import React, { useState, useRef, useEffect } from 'react';
import Button from '@/components/school-management/Button/Button';
import AppIcon from '@/components/school-management/AppIcon/AppIcon';
import styles from './DropdownMenu.module.scss';
import { AnchorRefProps, createAnchorWrapper } from '../Anchor/Anchor';

export type DropdownAction = string;

const DivAnchor = createAnchorWrapper('div');

type DropdownItem = {
  label: string;
  action: DropdownAction;
  danger?: boolean;
  onClick?: (id: string, object?: any) => void;
};

interface DropdownMenuProps {
  id: string;
  items?: DropdownItem[];
  hasStudents?: boolean;
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ id, items, hasStudents }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const anchorRef = useRef<AnchorRefProps>(null);

  const handleAction = (item: DropdownItem) => {
    const { action, onClick } = item;
    console.log(`Action selected: ${action}`);
    onClick?.(id);
    anchorRef.current?.close();
  };

  const actions: DropdownItem[] = items && items.length > 0 ? items : [];
  return (
    <>
      <DivAnchor
        ref={anchorRef}
        trigerType='click'
        autoClose={true}
        stayInView={true}
        tooltip={
          <div ref={menuRef} className={styles.dropdownMenu}>
            {actions.map((item, index) => {
              if (!hasStudents && index === 0) {
                return null;
              }
              return (
                <div key={item.action} className={styles.menuItem}>
                  <button
                    onClick={() => handleAction(item)}
                    className={`${styles.menuButton} ${item.danger ? styles.danger : ''}`}
                  >
                    {item.label}
                  </button>

                  <hr className={styles.menuDivider} />
                </div>
              );
            })}
          </div>
        }
        renderTooltipPosition={anchorPosition => {
          return {
            top: anchorPosition.top,
            left: anchorPosition.left - 170,
          };
        }}
      >
        <div className={styles.dropdownContainer} ref={containerRef}>
          <Button className={styles.dropdownButton} secondary>
            <AppIcon icon='optionsButton' width={4} height={18} />
          </Button>
        </div>
      </DivAnchor>
    </>
  );
};

export default DropdownMenu;
